import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  LuPlane, LuMail, LuPhone, LuMapPin,
  LuNewspaper, LuFileText, LuDownload, LuCircleCheck,
  LuArrowRight, LuShieldCheck,
} from 'react-icons/lu';
import { FaXTwitter, FaLinkedin, FaYoutube, FaInstagram } from 'react-icons/fa6';
import { generateBrochurePDF } from '../../utils/generateBrochurePDF';
import logo from '../../loggo.png';

// const SOCIALS = [
//   { icon: <FaXTwitter size={16} />,  href: '#!', label: 'X (Twitter)' },
//   { icon: <FaLinkedin size={16} />,  href: '#!', label: 'LinkedIn' },
//   { icon: <FaYoutube size={16} />,   href: '#!', label: 'YouTube' },
//   { icon: <FaInstagram size={16} />, href: '#!', label: 'Instagram' },
// ];

const EXPLORE_LINKS = [
  { to: '/',             label: 'Home' },
  { to: '/how-it-works', label: 'How It Works' },
  { to: '/technology',   label: 'Technology' },
  { to: '/types',        label: 'Conveyor Types' },
  { to: '/safety',       label: 'Safety Features' },
];

const RESOURCE_LINKS = [
  { to: '/newsletter',  label: 'Newsletter', icon: <LuNewspaper size={13} />, accent: 'var(--primary)' },
  { to: '/brochure',    label: 'Free Brochure', icon: <LuFileText size={13} />, accent: 'var(--accent)' },
  { to: '/contact#faq', label: 'FAQ' },
  { to: '/contact',     label: 'Contact Us' },
];

const LEGAL_LINKS = [
  { to: '/privacy',       label: 'Privacy Policy' },
  { to: '/terms',         label: 'Terms of Use' },
  { to: '/accessibility', label: 'Accessibility' },
];

function Footer() {
  const year             = new Date().getFullYear();
  const [nl, setNl]      = useState('');
  const [toast, setToast]= useState({ show: false, msg: '' });
  const timer            = useRef(null);

  const showToast = (msg) => {
    clearTimeout(timer.current);
    setToast({ show: true, msg });
    timer.current = setTimeout(() => setToast(t => ({ ...t, show: false })), 3200);
  };

  return (
    <>
      <footer className="footer" role="contentinfo">
        <div className="container">

          {/* ── Main grid ── */}
          <div className="footer-grid">

            {/* Brand + newsletter inline */}
            <div className="footer-brand">
              <Link to="/" className="nav-logo" style={{ display: 'inline-flex' }} aria-label="AeroConveyor home">
                <img src={logo} alt="AeroConveyor Logo" width="120" />
              </Link>
              <p>
                The definitive ki solution resource on airport baggage conveyor belt systems —
                the invisible backbone of modern air travel.
              </p>

              {/* Contact info */}
              <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
                {[
                  { icon: <LuMail size={14} />,   text: 'info@kiinnovation.in', href: 'mailto:info@kiinnovation.in' },
                  { icon: <LuPhone size={14} />,  text: '+91 92281 66525', href: 'tel:+18005553358' },
                  { icon: <LuMapPin size={14} />, text: '402-405 Astha Shoppers NearBy BhagvanMahavir Collage, Vesu,Surat -395007', href: null },
                ].map((item, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '.82rem', color: 'var(--text-muted)' }}>
                    <span style={{ color: 'var(--primary)', flexShrink: 0 }}>{item.icon}</span>
                    {item.href
                      ? <a href={item.href} style={{ color: 'var(--text-muted)', transition: 'color .2s' }} onMouseEnter={e => e.currentTarget.style.color='var(--primary)'} onMouseLeave={e => e.currentTarget.style.color='var(--text-muted)'}>{item.text}</a>
                      : <span>{item.text}</span>
                    }
                  </div>
                ))}
              </div>

              {/* Inline newsletter */}
              <div className="footer-nl-inline">
                <div className="footer-nl-label">
                  <LuNewspaper size={13} style={{ color: 'var(--primary)' }} /> Monthly Newsletter
                </div>
                <form
                  className="footer-nl-form"
                  onSubmit={e => { e.preventDefault(); showToast("You're subscribed!"); setNl(''); }}
                  noValidate
                >
                  <input
                    type="email"
                    placeholder="your@email.com"
                    value={nl}
                    onChange={e => setNl(e.target.value)}
                    required
                    aria-label="Newsletter email"
                  />
                  <button type="submit" className="btn btn-sm btn-primary">
                    Subscribe
                  </button>
                </form>
                <Link to="/newsletter" className="footer-nl-more">
                  View all newsletter issues <LuArrowRight size={11} />
                </Link>
              </div>

              {/* Socials */}
              {/* <div className="footer-socials" style={{ marginTop: 20 }}>
                {SOCIALS.map((s, i) => (
                  <a key={i} href={s.href} className="footer-social" aria-label={s.label}>
                    {s.icon}
                  </a>
                ))}
              </div> */}
            </div>

            {/* Explore */}
            <div className="footer-col">
              <h4>Explore</h4>
              <ul>
                {EXPLORE_LINKS.map((l, i) => (
                  <li key={i}><Link to={l.to}>{l.label}</Link></li>
                ))}
              </ul>
            </div>

            {/* Resources + Legal */}
            <div className="footer-col">
              <h4>Resources</h4>
              <ul>
                {RESOURCE_LINKS.map((l, i) => (
                  <li key={i}>
                    <Link to={l.to} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      {l.icon && <span style={{ color: l.accent, flexShrink: 0 }}>{l.icon}</span>}
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <h4 style={{ marginTop: 28 }}>Legal</h4>
              <ul>
                {LEGAL_LINKS.map((l, i) => (
                  <li key={i}><Link to={l.to}>{l.label}</Link></li>
                ))}
              </ul>
            </div>

            {/* Brochure CTA card */}
            <div className="footer-col">
              <h4>Free Download</h4>
              <div className="footer-brochure-card">
                <div className="fbc-icon">
                  <LuFileText size={26} />
                </div>
                <div className="fbc-title">Technical Brochure</div>
                <div className="fbc-desc">
                  60-page PDF guide covering every aspect of airport baggage conveyor systems — completely free.
                </div>
                <ul className="fbc-points">
                  {['System architecture diagrams', 'RFID & AI technology guide', 'Safety & maintenance protocols'].map((p, i) => (
                    <li key={i}>
                      <LuShieldCheck size={11} style={{ color: 'var(--accent-3)', flexShrink: 0 }} />
                      {p}
                    </li>
                  ))}
                </ul>
                <Link to="/brochure" className="btn btn-primary btn-sm" style={{ width: '100%', justifyContent: 'center', marginTop: 4 }}
                  onClick={e => { e.preventDefault(); generateBrochurePDF(); }}>
                  <LuDownload size={14} /> Download Free PDF
                </Link>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="footer-bottom">
            <span>© {year} KI INNOVATION. All rights reserved by KI SOLUTION.</span>
            <span style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
            </span>
          </div>
        </div>
      </footer>

      {/* Toast */}
      <div className={`toast${toast.show ? '' : ' hidden'}`} role="status" aria-live="polite">
        <LuCircleCheck size={18} style={{ color: 'var(--accent-3)', flexShrink: 0 }} />
        {toast.msg}
      </div>
    </>
  );
}

export default Footer;
